// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"4ecc9915","535":"e77760f7","761":"d2680966","860":"27750380","870":"e3923d63"}[chunkId] + ".css";
};